import { Button } from "web/components"

import { DayPicker } from "web/components"

import useModals from "./useModals"

function PickDateModal({ respond, date }) {
  return (
    <div>
      <DayPicker value={date} onChange={(date) => respond(date)} />
      <div className="p-4">
        <Button disabled={!date} onClick={() => respond(null)}>
          Clear
        </Button>
      </div>
    </div>
  )
}

export default function usePickDateModal() {
  const { showModal } = useModals()

  return async function ({ title, date }) {
    return await showModal({
      title,
      fullScreen: false,
      heightPixels: 480,
      widthPixels: 285,
      component: ({ respond }) => (
        <PickDateModal respond={respond} date={date} />
      ),
    })
  }
}
